import {css} from '@emotion/css';

const styles = {
  container: css`
    label: forgotPasswordForm;
    max-width: 50rem;
    margin: 0 auto;
  `,
};

export default styles;
